export default __webpack_public_path__ + "static/media/Ente.7e30e395.webp";